import React from "react";

function Wrapper({ className = "", classNameChildren = "", children }) {
  return (
    <div className={`w-full  mb-[60px]  px-4 ${className} `}>
      <div className={`max-w-6xl mx-auto ${classNameChildren}`}>{children}</div>
    </div>
  );
}
export default Wrapper;
